import { TimeSeriesGranularity } from 'dashboards/types/time';
import { ChartType } from 'types/dashboard_widget';

import { HEATMAP_CHART_GRANULARITIES } from 'dashboards/services/heatmap';

export function isGranularityOptionDisabled(
  granularity: TimeSeriesGranularity,
  chartType: ChartType
) {
  if (granularity === 'AUTO') {
    return false;
  }

  switch (chartType) {
    case 'timeseries-heatmap':
      return !HEATMAP_CHART_GRANULARITIES.includes(granularity);
    default:
      return false;
  }
}
